<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { ADMIN_MICOAPP_API } from "@/config/social-api";

/**
 * Starter page component
 */
export default {
  page() {
    return {
      title: this.title,
      meta: [{ name: "description" }],
    };
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Starter page",
      items: [
        {
          text: "Utility",
          href: "/",
        },
        {
          text: "Starter page",
          active: true,
        },
      ],
      loading: false,
      userinfo: [],
      micoapplist: [],
    };
  },
  mounted() {
    this.userinfo = JSON.parse(localStorage.getItem("user"));
    this.title = this.$t("menuitems.icp.micoapp.list");
    this.items = [
      {
        text: this.$t("menuitems.micoapp.text"),
        href: "/",
      },
      {
        text: this.$t("menuitems.icp.micoapp.list"),
        active: true,
      },
    ];
    this.getmicoapplist();
  },
  methods: {
    getmicoapplist() {
      var that = this;
      that.loading = true;
      that.$axios
        .post(
          ADMIN_MICOAPP_API,
          {
            action: "getmicoapplist",
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.loading = false;
          that.micoapplist = response.data.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    createmcioapp() {
      var that = this;
      if (that.micoapplist.length > 0) {

        that.$router.push({ path: "/micoapp/create" });

      } else {
        that.$router.push({ path: "/micoapp/create" });
      }
    }
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card micoapp-card">
          <div class="card-body" v-loading="loading">
            <div class="micoapp-toolbar">
              <div class="micoapp-title">
                <h5>小程序列表</h5>
                <p>集中管理你的小程序与配置项</p>
              </div>
              <el-button type="primary" round icon="el-icon-plus" @click="createmcioapp">
                创建小程序
              </el-button>
            </div>
            <div v-if="micoapplist.length === 0" class="micoapp-empty">
              <div class="micoapp-empty-icon">+</div>
              <div class="micoapp-empty-title">暂无小程序</div>
              <div class="micoapp-empty-subtitle">点击右上角创建你的第一个小程序</div>
            </div>
            <div v-else class="micoapp-card-grid">
              <router-link
                v-for="item in micoapplist"
                :key="item.appid"
                :to="{ path: '/micoapp/' + item.appid }"
                class="micoapp-list-card"
              >
                <div class="micoapp-list-card-inner">
                  <div class="micoapp-list-card-avatar">
                    <el-avatar :size="64" :src="item.head_img">
                      <span>{{ (item.niconame || '').charAt(0) }}</span>
                    </el-avatar>
                  </div>
                  <div class="micoapp-list-card-name">{{ item.niconame }}</div>
                  <div class="micoapp-list-card-appid">{{ item.appid }}</div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.micoapp-card .card-body {
  padding: 1.75rem;
}

.micoapp-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.25rem;
  gap: 1rem;
}

.micoapp-title h5 {
  font-weight: 700;
  margin: 0 0 0.25rem 0;
}

.micoapp-title p {
  margin: 0;
  color: #6b7280;
  font-size: 0.9rem;
}

.micoapp-card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 1.25rem;
}

.micoapp-list-card {
  display: block;
  text-decoration: none;
  color: inherit;
  border-radius: 16px;
  overflow: hidden;
  background: #fff;
  border: 1px solid #e5e7eb;
  transition: all 0.2s ease;
}

.micoapp-list-card:hover {
  border-color: #2d6cdf;
  box-shadow: 0 8px 24px rgba(45, 108, 223, 0.12);
}

.micoapp-list-card-inner {
  aspect-ratio: 1;
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.micoapp-list-card-avatar {
  margin-bottom: 0.75rem;
}

.micoapp-list-card-name {
  font-weight: 600;
  font-size: 0.95rem;
  margin-bottom: 0.35rem;
  color: #1f2937;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}

.micoapp-list-card-appid {
  font-size: 0.75rem;
  color: #94a3b8;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}

.micoapp-empty {
  padding: 2.5rem 0 3rem;
  text-align: center;
  color: #94a3b8;
}

.micoapp-empty-icon {
  width: 56px;
  height: 56px;
  border-radius: 16px;
  background: #e7f0ff;
  color: #2d6cdf;
  font-size: 28px;
  line-height: 56px;
  margin: 0 auto 0.75rem;
}

.micoapp-empty-title {
  font-weight: 600;
  color: #1f2937;
}

.micoapp-empty-subtitle {
  font-size: 0.9rem;
  margin-top: 0.35rem;
}

@media (max-width: 768px) {
  .micoapp-toolbar {
    flex-direction: column;
    align-items: flex-start;
  }

  .micoapp-card-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
